import { $GET, $POST } from '@/api/gateway/gatewayMethods';

import { 
  GET_LIST_EINVOICE, 
  GET_LIST_SEARCH_STATUS, 
  GET_LIST_SEARCH_AND_HEADER,
  GET_LIST_MODULE,
  GET_EINVOICE_CONFIGURATION,
  UPDATE_EINVOICE_CONFIGURATION,
  GET_PAYMENT_METHODS,
  CREATE_EINVOICE,
  GET_DETAIL_EINVOICE,
  CREATE_DRAFT_EINVOICE,
  UPDATE_SEARCH_BAR_BY_FILTER,
  ADJUST_REPLACE_EINVOICE,
  DELETE_EINVOICE,
  CANCEL_EINVOICE,
  PUBLISH_EINVOICE,
  GET_LIST_INVOICE_FROM_MODULE,
  GET_LIST_INVOICE_DETAIL_FROM_MODULE,
  SIGN_EINVOICE,
  VIEW_PDF,
  PREVIEW_PDF,
  CHANGE_EINVOICE,
  EXPORT_EXCEL,
  GET_NUMBER_EINVOICE_UPDATE_TAXAUTHORITY,
  SEND_INVOICE_CQT,
  GET_LIST_HOTEL_BY_MODULE,
  GET_INVOICE_STATUS_CQT,
  UPDATE_INVOICE_STATUS_CQT_MUL,
  GET_AUTO_LIST_INVOICE_FROM_MODULE,
  GET_DETAIL_EINVOICE_RESERVATION_THIRD_API,
  SEARCH_BY_EZINVOICEID,
  EDIT_DRAFT_EINVOICE,
  PREVIEW_TEMP_PDF_EINVOICE,
  CREATE_INTERNAL_DRAFT_EINVOICE,
  EDIT_INTERNAL_DRAFT_EINVOICE,
  GET_INTERNAL_STATUS,
  CREATE_MULTI_PUBLISH_EINVOICE,
  DELETE_INTERNAL_DRAFT_EINVOICE
} from '@/api/endpoint-defines/e-invoice-management';

export const getListEInvoiceApi = ({ BodyData }) =>
  $POST({ EndPoint: GET_LIST_EINVOICE, BodyData });

export const getListSearchInputApi = () =>
  $GET({ EndPoint: GET_LIST_SEARCH_STATUS, QueryParameters: null })

export const getListSearchAndHeaderApi = ({ QueryParameters }) =>
  $GET({ EndPoint: GET_LIST_SEARCH_AND_HEADER, QueryParameters })

export const getListModuleApi = () =>
  $GET({ EndPoint: GET_LIST_MODULE, QueryParameters: null })

// QueryParameters: { ConnectedProduct: 'DEFAULT' | 'EZONE' } - bỏ trống thì BE trả cấu hình DEFAULT
export const getEInvoiceConfiguration = ({ QueryParameters = null } = {}) =>
  $GET({ EndPoint: GET_EINVOICE_CONFIGURATION, QueryParameters })

export const updateEInvoiceConfiguration = ({ BodyData }) =>
  $POST({ EndPoint: UPDATE_EINVOICE_CONFIGURATION, BodyData })

export const getPaymentMethods = ( BodyData ) =>
  $POST({ EndPoint: GET_PAYMENT_METHODS, BodyData })

export const createEInvoice = ({ BodyData }) =>
  $POST({ EndPoint: CREATE_EINVOICE, BodyData })

export const getDetailEInvoice = ({ BodyData }) => 
  $POST({ EndPoint: GET_DETAIL_EINVOICE, BodyData })

export const createDraftEInvoice = ({ BodyData }) =>
  $POST({ EndPoint: CREATE_DRAFT_EINVOICE, BodyData })

export const UpdateSearchAddList=({BodyData}) =>
  $POST({EndPoint:UPDATE_SEARCH_BAR_BY_FILTER, BodyData})

export const adjustOrReplaceEInvoice = ({ BodyData }) => 
  $POST({ EndPoint: ADJUST_REPLACE_EINVOICE, BodyData })

export const deleteEInvoice = ({ BodyData }) =>
  $POST({ EndPoint: DELETE_EINVOICE, BodyData })

export const cancelEInvoice = ({ BodyData }) =>
  $POST({ EndPoint: CANCEL_EINVOICE, BodyData })

export const publishEInvoice = ({ BodyData }) =>
  $POST({ EndPoint: PUBLISH_EINVOICE, BodyData })

export const getListInvoiceFromModule = ({ BodyData }) =>
  $POST({ EndPoint: GET_LIST_INVOICE_FROM_MODULE, BodyData })

export const getListInvoiceDetailFromModule = ({ BodyData }) =>
  $POST({ EndPoint: GET_LIST_INVOICE_DETAIL_FROM_MODULE, BodyData })

export const signEInvoice = ({ BodyData }) =>
  $POST({ EndPoint: SIGN_EINVOICE, BodyData })

export const viewPdfEInvoice = ({ BodyData }) =>
  $POST({ EndPoint: VIEW_PDF, BodyData })

export const previewPdfEInvoice = ({ BodyData }) =>
  $POST({ EndPoint: PREVIEW_PDF, BodyData })

export const changeEInvoice = ({ BodyData }) => 
  $POST({ EndPoint: CHANGE_EINVOICE, BodyData })

export const exportExcelListEInvoiceApi = ({ BodyData }) => 
  $POST({ EndPoint: EXPORT_EXCEL, BodyData })

export const getNumberEinvoiceUpdateTaxAuthorityApi = ({ BodyData }) => 
  $POST({ EndPoint: GET_NUMBER_EINVOICE_UPDATE_TAXAUTHORITY, BodyData })

export const sendInvoieCQTApi = ({ BodyData }) => 
  $POST({ EndPoint: SEND_INVOICE_CQT, BodyData })

export const getListHotelByModuleApi = ({ BodyData }) =>
  $POST({ EndPoint: GET_LIST_HOTEL_BY_MODULE, BodyData })

export const getInvoieStatusCQTApi = ({ BodyData }) => 
  $POST({ EndPoint: GET_INVOICE_STATUS_CQT, BodyData })

export const updateInvoiceStatusCQTMulApi = ({ BodyData }) => 
  $POST({ EndPoint: UPDATE_INVOICE_STATUS_CQT_MUL, BodyData })

export const getAutoListInvoiceFromModule = ({ BodyData }) =>
  $POST({ EndPoint: GET_AUTO_LIST_INVOICE_FROM_MODULE, BodyData })

export const getDetailEInvoiceReservationThirdApi = ({ BodyData }) =>
  $POST({ EndPoint: GET_DETAIL_EINVOICE_RESERVATION_THIRD_API, BodyData })

export const searchByEzInvoiceIdApi = ({ BodyData }) =>
  $POST({ EndPoint: SEARCH_BY_EZINVOICEID, BodyData })

export const editDraftEInvoice = ({ BodyData }) =>
  $POST({ EndPoint: EDIT_DRAFT_EINVOICE, BodyData })

export const previewTempPdfEInvoice = ({ BodyData }) =>
  $POST({ EndPoint: PREVIEW_TEMP_PDF_EINVOICE, BodyData })

export const createInternalEinvoice = ({ BodyData }) =>
  $POST({ EndPoint: CREATE_INTERNAL_DRAFT_EINVOICE, BodyData })

export const editInternalDraftInvoices = ({ BodyData }) =>
  $POST({ EndPoint: EDIT_INTERNAL_DRAFT_EINVOICE, BodyData })

export const getInternalStatus = ({ BodyData }) =>
  $POST({ EndPoint: GET_INTERNAL_STATUS, BodyData })

export const createMultiPublishEInvoiceApi = ({ BodyData }) =>
  $POST({ EndPoint: CREATE_MULTI_PUBLISH_EINVOICE, BodyData })

// Chỉ dành cho hóa đơn lưu nháp nội bộ (ev55): xóa tại ezInvoice, không gọi nhà cung cấp như deleteEInvoice
export const deleteInternalDraftEInvoice = ({ BodyData }) =>
  $POST({ EndPoint: DELETE_INTERNAL_DRAFT_EINVOICE, BodyData })
